export const UPLOAD_EXPERTS_STEPS_DEFAULTS = [
  { text: "Upload PDFs, spreadsheets, and policy docs." },
  { text: "Gail reads, indexes, and learns your playbook." },
  { text: "Your team asks and gets answers with citations." },
];
